{
  "members": "Miembros",
  "inviteUser": "Invitar usuario",
  "invite": "Invitar",
  "inviteNeedsVerification": "Confirma tu dirección de correo para invitar personas a este espacio de trabajo.",
  "resendInvite": "Reenviar invitación",
  "removeUser": "Eliminar usuario",
  "settings": "Configuración",
  "createWorkspace": "Crear espacio de trabajo",
  "nudge": "Este es tu espacio de trabajo personal. ¿Quieres <newWorkspaceLink>crear un espacio de trabajo aparte</newWorkspaceLink> para tu equipo?",
  "roleUpdated": "Se actualizó el rol de {{name}} a {{role}}",
  "inviteResent": "Se reenvió la invitación por correo a {{name}}",
  "userRemoved": "Se eliminó a {{name}} del espacio de trabajo",
  "changeRoleTitle": "Cambiar el rol de {{name}}",
  "workspaceLanguage": {
    "title": "Idioma del espacio de trabajo",
    "description": "El idioma predeterminado de las invitaciones enviadas desde este espacio de trabajo y sus correos de notificación.",
    "label": "Idioma predeterminado",
    "success": "Se actualizó el idioma del espacio de trabajo"
  }
}
